<template>
  <div class="mit-admin-page mit-page">

    <v-container fluid>
        <BaseMitLoading :show="loading" :fullscreen="false"/>
        <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
            <b>{{ status.message }}</b>
        </v-snackbar>
        <v-row>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card" style="width:100%">
                <v-card-title>Admin - Reservable Spaces</v-card-title>
                <v-card-subtitle class="caption">Add and remove spaces that can be reserved.</v-card-subtitle>
                <v-divider></v-divider>

                <v-card-text>

                    <BaseMitDataTable
                      title="Reservable Spaces"
                      itemTitle="Space"
                      :editable="true"
                      :headers="headers"
                      :items="reservableSpaces"
                      :getNewItem="newReservableSpaceModel"
                      :getCopyItem="editReservableSpaceModel"
                      @edit="saveSpace"
                      @new="saveSpace"
                      @delete="deleteSpace"
                    >
                    <template v-slot:item.mitId="{ item }">
                      <div v-if="item.exists === false" style="background-color: red;">{{item.mitId}}</div>
                      <div v-else>{{ item.mitId }}</div>
                    </template>
                    <template v-slot:item.description="{ item }">
                      <div v-if="item.exists === false" style="background-color: red;">{{item.description}}</div>
                      <div v-else>{{ item.description }}</div>
                    </template>
                    <template v-slot:item.accessIds="{ item }">
                      <div v-if="item.accessIds.length > 0">{{item.accessIds.length}}</div>
                      <div v-else>ANY USER</div>
                    </template>
                        <template v-slot:dialogContents="{ item, dialogEdit }">
                            <div v-if="dialogEdit.show">
                                <v-combobox :clearable="true" :solo="true"
                                  label="Choose Space"
                                  v-model="selectedSpace"
                                  color="blue-grey lighten-2"
                                  :items="spaces"
                                  item-value="mitId"
                                  item-text="mitId"
                                  hide-no-data
                                  :loading="loadingSpaces"
                                  loader-height="5"
                                  :error-messages="errorsSpaces"
                                  placeholder="Start typing to Search"
                                  :return-object="false"
                                  :filter="filter"
                                >
                                <template v-slot:item="data">
                                  <template v-if="typeof data.item !== 'object'">
                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                  </template>
                                  <template v-else>
                                      <v-list-item-avatar>
                                          <v-icon v-if="data.item.type === 'building'">mdi-office-building-outline</v-icon>
                                          <!-- <v-icon v-else>mdi-door-closed</v-icon> -->
                                          <v-icon v-else>mdi-door-sliding</v-icon>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                          <!-- three-line -->
                                        <v-list-item-title v-html="data.item.mitId"></v-list-item-title>
                                        <v-list-item-subtitle v-html="data.item.org"></v-list-item-subtitle>
                                        <v-list-item-subtitle>{{data.item.useType}}</v-list-item-subtitle>
                                      </v-list-item-content>
                                  </template>
                                </template>
                                </v-combobox>

                                <BaseMitCsailMultiUsers title="Allowed Users" subtitle="Choose users allowed to reserve this space" :defaultSelectedUsers="selectedUsers" @user-changed="changedAllowedUser"/>
                            </div>
                        </template>
                    </BaseMitDataTable>
                </v-card-text>

            </v-card>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
  import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
  import BaseMitCsailUsers from '../../../base/components/csail-users/BaseMitCsailUsers.vue';
  import BaseMitCsailMultiUsers from '../../../base/components/csail-users/BaseMitCsailMultiUsers.vue';

  import MitSpacesApiService from '../../../base/services/BaseMitReserveSpacesService.js';

  export default {
    name: 'MitAdminPage',
    components: {
        BaseMitLoading,
        BaseMitDataTable,
        BaseMitCsailUsers,
        BaseMitCsailMultiUsers
    },
    data: function() {
      return {
          status:{
            display:false,
            timeout:3000,
            message:'Saved!',
            color:'primary'
          },
          loadingSpaces:true,
          loading:false,
          spaces:[],
          errorsSpaces:[],
          selectedSpace:null,
          selectedUsers:[],
          selectedGroups:[],
          allowedUsersControl:null,
          reservableSpaces:[],
          headers:[
              {text: 'MIT ID',sortable: true,value: 'mitId'},
              {text: 'Allowed Users (count)',sortable: true,value: 'accessIds'},
              {text: 'Description',sortable: true,value: 'description'},
            //   {text: 'Allowed Groups',sortable: true,value: 'accessGroups'},
            //   {text: 'Created Date',sortable: true,value: 'dates_local.createDt',},
              {text: 'Last Edit Date',sortable: true,value: 'dates_local.lastEditedDt',},
              {text: 'Last Edited By',sortable: false,value: 'lastEditedUser',},
              {text: 'Actions', value: 'actions', sortable: false, width: '5%', filterable:false, class: 'doNotPrint', cellClass:'doNotPrint' }
            ]
      }
    },
    created() {
        this.getReservableSpaces();
    },
    mounted() {

        MitSpacesApiService.getSpacesList()
          .then((spaces) => {
              this.spaces = spaces;
              this.loadingSpaces = false;
          })
          .catch((error) => {
              this.loadingSpaces = false;
              this.errorsSpaces = ['Error getting available spaces from space app.']
              console.log('ERROR:', error);
          });
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    methods: {
      filter (item, queryText, itemText) {
        return item.mitId.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
               item.org.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
               item.useType.toLowerCase().indexOf(queryText.toLowerCase()) > -1
      },
        getReservableSpaces(){
                this.loadingGet = true;

                MitSpacesApiService.getAdminReservableSpaces()
                  .then((data) => {
                      this.loadingGet = false;
                      this.reservableSpaces = data.spaces
                  })
                  .catch((error) => {
                      this.loadingGet = false;
                      this.status.message = 'An error occurred trying to get the reservable spaces.';
                      this.status.display = true;
                      this.status.color = 'red';
                      this.errorsSpaces = ['Error getting available spaces from space app.']
                      console.log('ERROR:', error);
                  });
        },
        changedAllowedUser(items){
            this.selectedUsers = items.map(a => a.id);
        },
        newReservableSpaceModel(){
            this.clearEditDialog();

            return {
                mitId:'',
                accessIds:[],
                accessGroups:[]
            }
        },
        editReservableSpaceModel(item){
            this.selectedSpace = item.mitId;

            this.selectedUsers = item.accessIds;
            this.selectedGroups = item.accessGroups;


            return {
                id:item.id,
                mitId:item.mitId,
                accessIds:item.accessIds,
                accessGroups:item.accessGroups
            }
        },
        clearEditDialog(){
            this.selectedSpace = null;
            this.selectedUsers = [];
            this.selectedGroups = [];
        },
        deleteSpace(item){
          this.loading = true;

          MitSpacesApiService.deleteReservableSpace(item)
              .then((result) => {
                  this.loading = false;
                  this.status.color = 'primary';
                  this.status.message = 'Removed '+item.mitId+'!';
                  this.status.display = true;

                  //refresh the spaces
                  this.getReservableSpaces();
              })
              .catch((error) => {
                  this.loading = false;
                  this.status.message = 'An error occurred trying to remove the space.';
                  this.status.display = true;
                  this.status.color = 'red';

                  //refresh the spaces
                  this.getReservableSpaces();
                  console.log('ERROR:', error);
              });
        },
        saveSpace(item){
            this.loading = true;

            item.mitId = this.selectedSpace;

            item.accessIds = this.selectedUsers;
            item.accessGroups = this.selectedGroups

            //Reset the last edits we did
            this.clearEditDialog();

            MitSpacesApiService.saveReservableSpace(item)
              .then((reservableSpace) => {
                  this.loading = false;
                  this.status.color = 'primary';
                  this.status.message = 'Added '+item.mitId+'!';
                  this.status.display = true;

                  //refresh the spaces
                  this.getReservableSpaces();
              })
              .catch((error) => {
                  this.loading = false;
                  this.status.message = 'An error occurred trying to add the space.';
                  this.status.display = true;
                  this.status.color = 'red';

                  //refresh the spaces
                  this.getReservableSpaces();
                  console.log('ERROR:', error);
              });

        }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
